export enum AccountTicketListType {
    EMAIL = 'EMAIL',
    TRAVELCARD = 'TRAVELCARD',
    RELATED_CARD = 'RELATED_CARD',
    VOUCHER = 'VOUCHER', // not sure it fits here
}
